<template>
  <div class="box">
    <div class="content-warp main-width">
      <Breadcrumb />
      <div class="userInfo">
        <img :src="userInfo.headSrc || defaultAvatar" alt="" />
        <div class="leftuser" style="width: 80%">
          <p>{{ userInfo.nickname }}</p>
          <div class="info">
            <a-icon type="phone" />
            <span>{{ userInfo.account }}</span>
            <span class="edit" @click="$refs.updateUserInfo.show()"> {{ $t('修改资料') }} </span>
            <span style="cursor: pointer;color:blue;" @click="$refs.userPwdModal.show()"> 修改账号密码</span>
          </div>
        </div>
        <span style="cursor: pointer;" @click="$refs.personalPlayerForm.show()"
          ><a-icon type="file-search" />{{ $t('个人报名运动员管理') }}</span
        >
      </div>
      <template v-if="userInfo.remark === 'manager'">
        <h3>组委会管理</h3>
        <div class="my-match">
          <div class="my-list">
            <div class="my-item">
              <div class="right">
                <div class="org" @click="handleOrg('/Organizing')">单位名单管理</div>
                <div class="org" @click="handleOrg('/OrganizingPlayer')">运动员审核</div>
                <div class="org" @click="handleOrg('/OrganizingStaff')">带队成员审核</div>
              </div>
            </div>
          </div>
        </div>
      </template>
      
      <div class="my-match" v-if="refereeList.length > 0">
        <div class="my-list">
          <div class="my-item" v-for="(item, index) in refereeList" :key="index">
            <div class="left">
              <!-- <img
                class="img"
                src="https://img1.baidu.com/it/u=4228853497,3891871492&fm=253&fmt=auto&app=138&f=JPEG?w=500&h=291"
                alt=""
              /> -->
              <!-- <div class="status">已结束</div> -->
              <div class="title">{{ item.title }}</div>
            </div>
            <div class="right">
              <!-- <div class="date">创建时间：2023-05-12</div> -->
              <div class="org" @click="handleReferee(item.matchId)">裁判审核</div>
            </div>
          </div>
        </div>
      </div>
      <h3>{{ $t('我的机构') }}</h3>
      <div class="agencyBox" v-if="myAgencys.length > 0">
        <div class="agencyCrad" v-for="(mag, index) in myAgencys" :key="index" @click="gotoAgencyManage(mag)">
          <div class="craditem" :key="index">
            <div class="cradflex">
              <img :src="mag.unitLogo || defaultLogo" alt="" />
              <span class="title">{{ mag.unitName }}</span>
            </div>
            <a-icon type="right" class="icon" />
          </div>
        </div>
      </div>
      <!-- 没有机构的时候 -->
      <div class="nodata" v-if="myAgencys.length === 0 && userInfo.remark !== '北京学校账号'">
        <img src="../../assets/userdef.png" alt="" />
        <p class="text">{{ $t('你还没有自己的机构，点击创建机构') }}</p>
        <a-button type="danger" @click="$refs.editAgency.show(null)">
          {{ $t('成为机构用户') }}
        </a-button>
      </div>
      <div v-if="entitledAgencys.length > 0">
        <h3>{{ $t('授权机构') }}</h3>
        <div class="agencyBox">
          <div class="agencyCrad" v-for="(eag, index) in entitledAgencys" :key="index" @click="gotoAgencyManage(eag)">
            <div class="craditem">
              <div class="cradflex">
                <img :src="eag.unitLogo || defaultLogo" alt="" />
                <span class="title">{{ eag.unitName }}</span>
              </div>
              <a-icon type="right" class="icon" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <UpdateUserInfo ref="updateUserInfo" />
    <PersonalPlayerForm ref="personalPlayerForm" />
    <UserPwdModal ref="userPwdModal" />
    <EditAgency ref="editAgency" @ok="refreshAgency" />
  </div>
</template>
<script>
import store from '@/store'
import matchFun from '@comm/utils/matchFun'
import Breadcrumb from '@comm/components/center/Breadcrumb'
import UpdateUserInfo from '@comm/components/center/modal/UpdateUserInfo'
import UserPwdModal from '@comm/components/center/modal/UserPwdModal'
import EditAgency from '@comm/components/modal/EditAgency'
import PersonalPlayerForm from '@comm/components/center/PersonalPlayerForm'
import { mapState } from 'vuex'
export default {
  name: 'Index',
  components: {
    Breadcrumb,
    UpdateUserInfo,
    UserPwdModal,
    EditAgency,
    PersonalPlayerForm,
  },
  mounted () {
    // 初始化
    this.queryData()
    this.findRefereeData()
  },
  data () {
    return {
      current: 1,
      matchFun: matchFun,
      defaultAvatar: require('../../assets/userdef.png'),
      myAgencys: [],
      entitledAgencys: [],
      refereeList: []
    }
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.user.userInfo,
    }),
  },
  methods: {
    findRefereeData () {
      this.$api.match.refereeAuthList().then(res => {
        if (res.status === 0) {
          this.refereeList = res.data
        }
      }).catch(err => {
        console.log(err)
        this.$message.error('获取列表失败')
      })
    },
    handleMatchDetail () {
      console.log('111', '跳转赛事详情')
    },
    handleOrg (type) {
      console.log('222', '跳转组委会')
      this.$router.push({ path: type})
    },
    handleReferee (matchId) {
      this.$router.push({ path: '/OrganizingReferee', query: {matchId: matchId}})
    },
    queryData () {
      this.myAgencys = []
      this.entitledAgencys = []
      this.$api.high
        .myAgencyList({ accountId: this.userInfo.id })
        .then((res) => {
          if (res.status === 0) {
            res.data.forEach((item) => {
              if (item.isMain === 1) {
                this.myAgencys.push(item)
              } else {
                this.entitledAgencys.push(item)
              }
            })
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    gotoAgencyManage (item) {
      store.commit('agency/MATCH_CHANGE_AGENCY_INFO', item)
      this.$router.push({ path: '/CenterAgency', query: { agencyId: item.agencyId, step: 'CenterAuth' } })
    },
    refreshAgency () {
      this.queryData()
    },
  },
}
</script>
<style lang="scss" scoped>
.box {
  background: #f0f1f2;
}
.main-width {
  width: 1200px;
  margin-left: auto;
  margin-right: auto;
}
.content-warp {
  padding: 10px 0;
}
.userInfo {
  display: flex;
  align-items: center;
  background: #fff;
  padding: 20px;
  margin: 10px 0;
  border-radius: 5px;
  img {
    width: 70px;
    height: 70px;
    border-radius: 35px;
    margin-right: 20px;
  }
  .leftuser {
    p {
      font-weight: 600;
      margin-bottom: 8px;
      font-size: 18px;
      display: inline-block;
    }

    .info {
      position: relative;
      span {
        margin: 0 3px;
      }
      .edit {
        color: #43a3ff;
        cursor: pointer;
      }
    }
  }
}
// 我的赛事
.my-match {
  width: 1200px;
  margin: 0 auto;
  background-color: #fff;
  margin-bottom: 10px;
  border-radius: 10rpx;
  padding: 30px 30px 70px 30px;
  box-sizing: border-box;
  position: relative;
  .my-list {
    width: 100%;

    .my-item {
      width: 100%;
      height: 60px;
      display: flex;
      justify-content: space-between;
      color: #333;
      border-bottom: 2px solid #f2f2f2;
      padding-bottom: 10px;
      .left {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        cursor: pointer;
        .img {
          width: 60px;
          height: 60px;
          border-radius: 50%;
          margin-right: 10px;
        }
        .status {
          width: 60px;
          background-color: #bbbbbb;
          color: #fff;
          text-align: center;
          border-radius: 5px;
          margin-right: 10px;
          font-weight: bold;
        }
        .title {
          font-size: 16px;
          font-weight: 700;
        }
      }
      .right {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        .date {
          color: #666666;
          font-size: 14px;
        }
        .org {
          padding: 10px 20px;
          height: 40px;
          color: #fff;
          border-radius: 10px;
          background-color: #be1e28;
          display: flex;
          justify-content: center;
          align-items: center;
          margin-left: 20px;
          cursor: pointer;
        }
        .org:hover {
          opacity: 0.8;
        }
      }
    }
    .pagina {
      display: flex;
      position: absolute;
      bottom: 20px;
      left: 50%;
      transform: translateX(-50%);
    }
  }
}
.agencyBox {
  background: #fff;
  border-radius: 5px;
  margin-bottom: 10px;
  display: flex;
  padding: 20px;
  flex-wrap: wrap;
  justify-content: space-between;
  .agencyCrad {
    width: 560px;
    background-color: #fff;
    box-shadow: 0px 0px 3px 0px #dbdbdb;
    border-radius: 8px;
    display: flex;
    justify-content: space-between;
    cursor: pointer;
    padding: 20px 35px;
    margin-bottom: 20px;
    .craditem {
      display: flex;
      align-items: center;
      width: 100%;
      justify-content: space-between;
      .cradflex {
        display: flex;
        align-items: center;
        img {
          width: 75px;
          height: 75px;
          margin-right: 15px;
          border-radius: 50%;
        }
        .title {
          font-size: 18px;
          font-weight: 600;
          color: #333333;
        }
      }
      .icon {
        font-size: 20px;
        color: #dbdbdb;
      }
    }
  }
}
.nodata {
  background: #fff;
  border-radius: 5px;
  padding: 20px;
  text-align: center;
  margin-bottom: 10px;
  .text {
    color: #999;
    margin: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/daoba-match/components/center/Index.vue